import copyFolder from './copyFolder'
import createFolder from './createFolder'
import deleteFolder from './deleteFolder'
import deleteItem from './deleteItem'
import getFolderContent from './getFolderContent'
import getFolders from './getFolders'
import getItemFolders from './getItemFolders'
import publishFolder from './publishFolder'
import putItem from './putItem'
import sendFolderNotification from './sendFolderNotification'
import shareFolder from './shareFolder'
import unpublishFolder from './unpublishFolder'
import unshareFolder from './unshareFolder'
import updateFolder from './updateFolder'
import updateFolderPosition from './updateFolderPosition'
import updateItemPosition from './updateItemPosition'

export default {
  copyFolder,
  createFolder,
  deleteFolder,
  deleteItem,
  getFolderContent,
  getFolders,
  getItemFolders,
  publishFolder,
  putItem,
  sendFolderNotification,
  shareFolder,
  unpublishFolder,
  unshareFolder,
  updateFolder,
  updateFolderPosition,
  updateItemPosition,
}
